export default {"src":"/_next/static/media/individual-icon.c396fe55.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};